var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.quickLinks),function(link){return _c('quick-link',{attrs:{"label":link.label,"route":link.url,"icon":link.icon}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }